var _style, _path, _path2, _path3, _g, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _g2, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _defs16, _defs17, _defs18, _defs19;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoOntelWh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 114 26.25",
    style: {
      enableBackground: "new 0 0 114 26.25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{clip-path:url(#SVGID_00000049924163243820065150000005563968216117827995_);fill:#FFFFFF;}\r\n\t.st2{clip-path:url(#SVGID_00000060005751860502465620000016065737376921011873_);fill:#FFFFFF;}\r\n\t.st3{clip-path:url(#SVGID_00000065064294281651046740000013982353815831917706_);fill:#FFFFFF;}\r\n\t.st4{clip-path:url(#SVGID_00000128467976003427461830000002609512819690077877_);fill:#FFFFFF;}\r\n\t.st5{clip-path:url(#SVGID_00000023967027623258662250000006908464045401419178_);fill:#FFFFFF;}\r\n\t.st6{clip-path:url(#SVGID_00000165947316139599245940000000414500941656444046_);fill:#FFFFFF;}\r\n\t.st7{clip-path:url(#SVGID_00000168095912748191736580000005539763093289222567_);fill:#FFFFFF;}\r\n\t.st8{clip-path:url(#SVGID_00000076589930326498824390000000738420166338712749_);fill:#FFFFFF;}\r\n\t.st9{clip-path:url(#SVGID_00000027582465973517298970000003205554093005103801_);fill:#FFFFFF;}\r\n\t.st10{clip-path:url(#SVGID_00000080919595798534965660000010254850503027667365_);fill:#FFFFFF;}\r\n\t.st11{clip-path:url(#SVGID_00000000934195874561248850000014409932094538475678_);fill:#FFFFFF;}\r\n\t.st12{clip-path:url(#SVGID_00000096766401249608367430000007464001208795288707_);fill:#FFFFFF;}\r\n\t.st13{clip-path:url(#SVGID_00000178907286042061106920000001864983736379645879_);fill:#FFFFFF;}\r\n\t.st14{clip-path:url(#SVGID_00000108289891509684856960000002911318741397248959_);fill:#FFFFFF;}\r\n\t.st15{clip-path:url(#SVGID_00000087377496183884662230000003733059584019232657_);fill:#FFFFFF;}\r\n\t.st16{clip-path:url(#SVGID_00000132088267199949054920000015683958397674721706_);fill:#FFFFFF;}\r\n\t.st17{clip-path:url(#SVGID_00000005953439815992518960000007061362794627959943_);fill:#FFFFFF;}\r\n\t.st18{clip-path:url(#SVGID_00000111909160752515766730000016344993869016230289_);fill:#FFFFFF;}\r\n\t.st19{clip-path:url(#SVGID_00000166663546075427496710000005247602700609916547_);fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.43,0.35h-6.3c-0.43,0-0.77,0.35-0.77,0.77v9.99L34.78,0.69c-0.14-0.21-0.38-0.34-0.64-0.34h-5.37 C28.35,0.35,28,0.7,28,1.12v24.01c0,0.43,0.35,0.77,0.77,0.77h6.3c0.43,0,0.77-0.35,0.77-0.77V15.11l7.68,10.46 c0.14,0.21,0.38,0.33,0.64,0.33h5.27c0.43,0,0.77-0.35,0.77-0.77V1.12C50.2,0.7,49.86,0.35,49.43,0.35z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.42,0.35h-20.7c-0.43,0-0.77,0.35-0.77,0.77v5.11C51.95,6.65,52.3,7,52.72,7h6.46v18.13 c0,0.43,0.35,0.77,0.77,0.77h6.23c0.43,0,0.77-0.35,0.77-0.77V7h6.46c0.43,0,0.77-0.35,0.77-0.77V1.12 C74.19,0.7,73.84,0.35,73.42,0.35z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.85,7c0.43,0,0.77-0.35,0.77-0.77V1.12c0-0.43-0.35-0.77-0.77-0.77H76.71c-0.43,0-0.77,0.35-0.77,0.77v24.01 c0,0.43,0.35,0.77,0.77,0.77h17.11c0.43,0,0.77-0.35,0.77-0.77v-5.11c0-0.43-0.35-0.77-0.77-0.77H83.78v-2.8h9.18 c0.43,0,0.77-0.35,0.77-0.77v-5.11c0-0.43-0.35-0.77-0.77-0.77h-9.18V7H93.85z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "106.64,22.8 107.4,22.8 107.02,21.72  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M113.23,19.25h-9.01V1.12c0-0.43-0.35-0.77-0.77-0.77h-6.3c-0.43,0-0.77,0.35-0.77,0.77v24.01 c0,0.43,0.35,0.77,0.77,0.77h16.08c0.43,0,0.77-0.35,0.77-0.77v-5.11C114,19.6,113.65,19.25,113.23,19.25z M105.67,23.77 c0,0.05-0.04,0.08-0.08,0.08h-1.3c-0.05,0-0.08-0.04-0.08-0.08v-2.4c0-0.05,0.04-0.08,0.08-0.08h0.11c0.05,0,0.08,0.04,0.08,0.08 v2.22h1.11c0.04,0,0.08,0.04,0.08,0.07V23.77z M108,23.82c-0.01,0.02-0.03,0.03-0.06,0.03h-0.12c-0.03,0-0.06-0.02-0.07-0.05 l-0.26-0.74h-0.95l-0.26,0.74c-0.01,0.03-0.04,0.05-0.07,0.05h-0.12c-0.02,0-0.05-0.01-0.06-0.03s-0.02-0.05-0.01-0.07l0.86-2.4 c0.01-0.03,0.04-0.05,0.07-0.05h0.14c0.03,0,0.06,0.02,0.07,0.05l0.85,2.4C108.02,23.77,108.01,23.8,108,23.82z M110.03,23.16 c0,0.14-0.03,0.26-0.09,0.36c-0.06,0.11-0.15,0.19-0.26,0.25s-0.25,0.09-0.4,0.09h-0.84c-0.05,0-0.08-0.04-0.08-0.08v-2.4 c0-0.05,0.04-0.08,0.08-0.08h0.77c0.15,0,0.28,0.02,0.39,0.08c0.11,0.05,0.2,0.13,0.26,0.24c0.06,0.1,0.09,0.22,0.09,0.36 c0,0.16-0.04,0.3-0.11,0.41c-0.03,0.06-0.08,0.1-0.13,0.14c0.03,0.02,0.05,0.03,0.08,0.05c0.08,0.06,0.14,0.14,0.19,0.24 C110.03,22.92,110.05,23.04,110.03,23.16z M111.98,23.53c-0.08,0.11-0.18,0.2-0.31,0.26s-0.27,0.09-0.44,0.09 c-0.16,0-0.3-0.03-0.42-0.09c-0.13-0.06-0.23-0.14-0.3-0.24c-0.07-0.1-0.11-0.23-0.12-0.36c0-0.02,0-0.04,0.02-0.06 c0.02-0.01,0.04-0.02,0.06-0.02h0.11c0.04,0,0.08,0.03,0.08,0.07c0.01,0.09,0.03,0.17,0.08,0.23s0.12,0.11,0.2,0.15 c0.18,0.07,0.44,0.07,0.62-0.01c0.08-0.04,0.15-0.1,0.2-0.17c0.05-0.07,0.07-0.15,0.07-0.24c0-0.1-0.03-0.18-0.1-0.25 c-0.08-0.07-0.2-0.14-0.38-0.19l-0.27-0.08c-0.2-0.07-0.36-0.15-0.46-0.26s-0.16-0.25-0.16-0.41c0-0.13,0.04-0.25,0.11-0.36 c0.07-0.11,0.17-0.19,0.29-0.25c0.24-0.12,0.57-0.12,0.81,0c0.12,0.06,0.22,0.14,0.29,0.25c0.07,0.11,0.11,0.23,0.12,0.37 c0,0.02-0.01,0.04-0.02,0.06c-0.02,0.01-0.04,0.02-0.06,0.02h-0.1c-0.04,0-0.08-0.03-0.08-0.07c-0.01-0.09-0.03-0.17-0.08-0.24 c-0.05-0.07-0.11-0.12-0.19-0.16c-0.16-0.08-0.39-0.08-0.56,0c-0.08,0.04-0.14,0.09-0.19,0.16c-0.05,0.06-0.07,0.14-0.07,0.22 c0,0.1,0.03,0.18,0.1,0.25c0.07,0.08,0.19,0.13,0.34,0.18l0.27,0.08c0.21,0.07,0.38,0.15,0.49,0.26c0.12,0.12,0.18,0.26,0.16,0.43 C112.09,23.29,112.05,23.42,111.98,23.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.51,22.37c0.06-0.04,0.11-0.09,0.14-0.16c0.03-0.06,0.05-0.14,0.05-0.22c0-0.09-0.02-0.17-0.06-0.23 c-0.04-0.07-0.09-0.12-0.16-0.15c-0.07-0.03-0.16-0.05-0.26-0.05h-0.58v0.87h0.65C109.38,22.43,109.45,22.41,109.51,22.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.56,22.74c-0.08-0.04-0.16-0.06-0.26-0.06h-0.65v0.91h0.65c0.1,0,0.19-0.02,0.26-0.06 c0.08-0.04,0.13-0.09,0.17-0.15c0.04-0.07,0.06-0.14,0.06-0.23c0-0.09-0.02-0.17-0.06-0.24C109.69,22.84,109.63,22.78,109.56,22.74 z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M13.13,0c-0.97,0-1.91,0.11-2.82,0.31c-0.01,0.05-0.02,0.1-0.03,0.15l5.15,2.69 c0.25-0.27,0.6-0.44,0.99-0.44c0.06,0,0.12,0.01,0.18,0.02l0.84-1.99C16.08,0.27,14.63,0,13.13,0z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000145752832287716726780000012904592589379530917_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      clipPath: "url(#SVGID_00000145752832287716726780000012904592589379530917_)",
      fill: "#FFFFFF"
    },
    width: 26.25,
    height: 26.25
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000057128445857240237490000015639050557029918342_",
    d: "M15.29,4.81L7.04,7.62c0.01,0.06,0.02,0.11,0.02,0.17 c0,0.08-0.01,0.15-0.02,0.23l5.83,2.22c0.33-0.52,0.9-0.88,1.56-0.88c0.05,0,0.1,0.01,0.14,0.01l1.15-4.17 C15.55,5.11,15.4,4.97,15.29,4.81z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000057128445857240237490000015639050557029918342_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000067218202334798967030000001069099004258457257_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000057128445857240237490000015639050557029918342_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      clipPath: "url(#SVGID_00000067218202334798967030000001069099004258457257_)",
      fill: "#FFFFFF"
    },
    width: 26.25,
    height: 26.25
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000022558141485481458960000006793554277332309640_",
    d: "M10.97,18.93c0-0.04,0.01-0.09,0.01-0.13L6.3,17.04 c-0.07,0.11-0.15,0.2-0.25,0.29l3.79,6.5c0.15-0.05,0.31-0.08,0.48-0.08c0.04,0,0.08,0.01,0.13,0.01l1.15-3.69 C11.23,19.82,10.97,19.41,10.97,18.93z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000022558141485481458960000006793554277332309640_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000098208041520716632370000017947494846352126623_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000022558141485481458960000006793554277332309640_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      clipPath: "url(#SVGID_00000098208041520716632370000017947494846352126623_)",
      fill: "#FFFFFF"
    },
    width: 26.25,
    height: 26.25
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000123422626507668693260000005790289177621017729_",
    d: "M22.89,5.76l-5.29-1.1C17.51,4.84,17.38,5,17.22,5.12 l3.6,8.8c0.09-0.01,0.17-0.03,0.27-0.03c0.05,0,0.09,0.01,0.14,0.01l2.28-7.1C23.15,6.58,22.92,6.2,22.89,5.76z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000123422626507668693260000005790289177621017729_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000106834612565137089930000013820842371402373554_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000123422626507668693260000005790289177621017729_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      clipPath: "url(#SVGID_00000106834612565137089930000013820842371402373554_)",
      fill: "#FFFFFF"
    },
    width: 26.25,
    height: 26.25
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000071561437496216841450000016157695294933845167_",
    d: "M15.76,12.48c-0.34,0.35-0.81,0.57-1.33,0.57 c-0.05,0-0.09-0.01-0.14-0.01L13,17.77c0.16,0.09,0.29,0.21,0.4,0.36l6.11-2.4c-0.01-0.08-0.02-0.16-0.02-0.24 c0-0.19,0.04-0.37,0.1-0.55L15.76,12.48z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000071561437496216841450000016157695294933845167_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000152960420492504091250000005916622559930386056_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000071561437496216841450000016157695294933845167_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      clipPath: "url(#SVGID_00000152960420492504091250000005916622559930386056_)",
      fill: "#FFFFFF"
    },
    width: 26.25,
    height: 26.25
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000022518058543104399650000014126718971226191280_",
    d: "M7.64,1.21C5.98,1.98,4.5,3.08,3.3,4.44l1.48,1.9 c0.21-0.1,0.44-0.16,0.68-0.16c0.1,0,0.19,0.01,0.28,0.03L7.8,1.34C7.75,1.31,7.7,1.26,7.64,1.21z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000022518058543104399650000014126718971226191280_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000050663114356544219540000018125922068690590900_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000022518058543104399650000014126718971226191280_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      clipPath: "url(#SVGID_00000050663114356544219540000018125922068690590900_)",
      fill: "#FFFFFF"
    },
    width: 26.25,
    height: 26.25
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000063633153507442946910000012570610571035642275_",
    d: "M12.58,11.21c0-0.11,0.01-0.21,0.03-0.32L6.79,8.67 C6.73,8.76,6.66,8.85,6.58,8.93l5.36,8.71c0.12-0.04,0.25-0.06,0.38-0.06c0,0,0,0,0.01,0l1.29-4.72 C13.01,12.56,12.58,11.94,12.58,11.21z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000063633153507442946910000012570610571035642275_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000082331751514137091790000014741419554820593305_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000063633153507442946910000012570610571035642275_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      clipPath: "url(#SVGID_00000082331751514137091790000014741419554820593305_)",
      fill: "#FFFFFF"
    },
    width: 26.25,
    height: 26.25
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000142888838193960482570000009537730736965823648_",
    cx: 12.32,
    cy: 18.93,
    r: 0.65
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000142888838193960482570000009537730736965823648_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026130841762494615080000003926205905527223708_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000142888838193960482570000009537730736965823648_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      clipPath: "url(#SVGID_00000026130841762494615080000003926205905527223708_)",
      fill: "#FFFFFF"
    },
    width: 26.25,
    height: 26.25
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000053503500022435549920000004947140959436434105_",
    d: "M18.08,0.98L17.23,3c0.3,0.23,0.49,0.58,0.51,0.98 l5.29,1.1c0.06-0.11,0.13-0.21,0.21-0.3C21.88,3.11,20.11,1.8,18.08,0.98z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000053503500022435549920000004947140959436434105_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000141430466783258335500000017603217405449139091_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000053503500022435549920000004947140959436434105_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      clipPath: "url(#SVGID_00000141430466783258335500000017603217405449139091_)",
      fill: "#FFFFFF"
    },
    width: 26.25,
    height: 26.25
  }))), /*#__PURE__*/React.createElement("g", null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000021824463828242089090000003580529393759581575_",
    className: "st0",
    d: "M24.23,6.33c0.03,0,0.06-0.01,0.09-0.02 c-0.2-0.32-0.41-0.63-0.64-0.92c-0.06,0.09-0.1,0.2-0.1,0.32C23.58,6.05,23.88,6.33,24.23,6.33z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000143619398037952578410000013379968670241691066_",
    d: "M24.23,6.33c0.03,0,0.06-0.01,0.09-0.02 c-0.2-0.32-0.41-0.63-0.64-0.92c-0.06,0.09-0.1,0.2-0.1,0.32C23.58,6.05,23.88,6.33,24.23,6.33z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000143619398037952578410000013379968670241691066_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000046298538142981962070000001243154078173622405_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000143619398037952578410000013379968670241691066_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    y: 0.21,
    style: {
      clipPath: "url(#SVGID_00000046298538142981962070000001243154078173622405_)",
      fill: "#FFFFFF"
    },
    width: 26.25,
    height: 25.38
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000139993880622553334580000011606429726129372841_",
    d: "M6.57,16.16c0,0.08-0.01,0.15-0.02,0.22l4.68,1.77 c0.03-0.05,0.07-0.09,0.11-0.14L5.98,9.29C5.9,9.32,5.81,9.34,5.72,9.36l-0.31,5.27C6.08,14.82,6.57,15.43,6.57,16.16z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000139993880622553334580000011606429726129372841_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000124857629947539983520000001500592674045729972_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000139993880622553334580000011606429726129372841_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      clipPath: "url(#SVGID_00000124857629947539983520000001500592674045729972_)",
      fill: "#FFFFFF"
    },
    width: 26.25,
    height: 26.25
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000075134851054355361230000016761895251478003895_",
    d: "M20.17,14.19l-3.6-8.8c-0.06,0.01-0.11,0.02-0.17,0.02 h-0.01l-1.15,4.16c0.61,0.3,1.03,0.92,1.03,1.65c0,0.24-0.05,0.47-0.14,0.69l3.83,2.46C20.03,14.3,20.1,14.24,20.17,14.19z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000075134851054355361230000016761895251478003895_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000031208529294126980570000008276356332308708754_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000075134851054355361230000016761895251478003895_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      clipPath: "url(#SVGID_00000031208529294126980570000008276356332308708754_)",
      fill: "#FFFFFF"
    },
    width: 26.25,
    height: 26.25
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000129886426570795414080000009575409880511932082_",
    d: "M24.7,6.94c-0.15,0.05-0.3,0.09-0.47,0.09 c-0.02,0-0.04-0.01-0.06-0.01l-2.28,7.1c0.47,0.28,0.79,0.79,0.79,1.37c0,0.88-0.72,1.6-1.6,1.6c-0.55,0-1.04-0.28-1.32-0.7 l-6.11,2.39c0.01,0.05,0.01,0.1,0.01,0.15c0,0.74-0.6,1.35-1.35,1.35c-0.02,0-0.03,0-0.05-0.01l-1.15,3.69 c0.48,0.28,0.8,0.79,0.8,1.38c0,0.3-0.09,0.58-0.24,0.83c0.47,0.05,0.95,0.08,1.43,0.08c7.25,0,13.13-5.88,13.13-13.13 C26.25,10.89,25.69,8.78,24.7,6.94z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000129886426570795414080000009575409880511932082_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013904078936724308400000012162269715269076645_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000129886426570795414080000009575409880511932082_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      clipPath: "url(#SVGID_00000013904078936724308400000012162269715269076645_)",
      fill: "#FFFFFF"
    },
    width: 26.25,
    height: 26.25
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000064314231841503920630000002366182464158753169_",
    d: "M8.74,25.34c0-0.46,0.2-0.87,0.51-1.17l-3.79-6.5 c-0.15,0.05-0.31,0.08-0.48,0.08c-0.82,0-1.49-0.62-1.58-1.42l-2.7-0.3c-0.05,0.17-0.13,0.33-0.23,0.48 c1.12,4.18,4.25,7.53,8.29,8.97C8.75,25.44,8.74,25.39,8.74,25.34z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000064314231841503920630000002366182464158753169_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000028306441993596729200000011849051033499469449_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000064314231841503920630000002366182464158753169_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      clipPath: "url(#SVGID_00000028306441993596729200000011849051033499469449_)",
      fill: "#FFFFFF"
    },
    width: 26.25,
    height: 26.25
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000036250575244948565080000007530041309997724563_",
    d: "M2.84,4.99C2.01,6.03,1.35,7.2,0.87,8.47l3-0.68l0,0 c0-0.38,0.14-0.73,0.37-1.01L2.84,4.99z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000036250575244948565080000007530041309997724563_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000129202330707702243300000007536465238761145764_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000036250575244948565080000007530041309997724563_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      clipPath: "url(#SVGID_00000129202330707702243300000007536465238761145764_)",
      fill: "#FFFFFF"
    },
    width: 26.25,
    height: 26.25
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000128452722462933245480000010428754178303771543_",
    d: "M4.57,7.79c0,0.5,0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9 s-0.4-0.9-0.9-0.9C4.97,6.89,4.57,7.29,4.57,7.79z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000128452722462933245480000010428754178303771543_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000082337725222790940880000003275967801490591661_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000128452722462933245480000010428754178303771543_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      clipPath: "url(#SVGID_00000082337725222790940880000003275967801490591661_)",
      fill: "#FFFFFF"
    },
    width: 26.25,
    height: 26.25
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000169524059491355889160000005376336522209216187_",
    d: "M6.82,6.96l8.25-2.81c0-0.03-0.01-0.06-0.01-0.09 c0-0.1,0.01-0.2,0.03-0.29L9.95,1.08c-0.3,0.34-0.73,0.57-1.22,0.57c-0.1,0-0.19-0.01-0.28-0.03L6.39,6.49 C6.56,6.62,6.71,6.77,6.82,6.96z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000169524059491355889160000005376336522209216187_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080167282110663345040000006096186401144890786_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000169524059491355889160000005376336522209216187_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      clipPath: "url(#SVGID_00000080167282110663345040000006096186401144890786_)",
      fill: "#FFFFFF"
    },
    width: 26.25,
    height: 26.25
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000047770166216852661880000002764935574505396357_",
    d: "M4.03,8.47L0.58,9.25C0.2,10.48,0,11.78,0,13.13 c0,0.17,0.02,0.33,0.03,0.5l4.1-4.97C4.09,8.59,4.06,8.53,4.03,8.47z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000047770166216852661880000002764935574505396357_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000103967815299674783390000014503297599155877785_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000047770166216852661880000002764935574505396357_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      clipPath: "url(#SVGID_00000103967815299674783390000014503297599155877785_)",
      fill: "#FFFFFF"
    },
    width: 26.25,
    height: 26.25
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000026129615780240839510000014163136161494355373_",
    d: "M3.47,15.64c0.19-0.55,0.66-0.96,1.25-1.05l0.31-5.27 c-0.14-0.04-0.27-0.1-0.4-0.17l-4.27,5.18c0.23,0.28,0.38,0.63,0.41,1.02L3.47,15.64z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000026129615780240839510000014163136161494355373_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000133523688493298012250000008452371568891258262_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000026129615780240839510000014163136161494355373_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      clipPath: "url(#SVGID_00000133523688493298012250000008452371568891258262_)",
      fill: "#FFFFFF"
    },
    width: 26.25,
    height: 26.25
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOntelWh);
export default __webpack_public_path__ + "static/media/logo_ontel_wh.154ccf09da56dde6ad1af725b5b044f9.svg";
export { ForwardRef as ReactComponent };